export default __webpack_public_path__ + "static/media/Debarking Tool.55c853fe.PNG";